<script lang="ts" setup>
import { RouterLink, IconComp } from '@/components';
import type { MenuItem } from '@/objects/MenuItem';

const props = defineProps<{
    menuitem: MenuItem;
    eventID: number;
    size: 'BIG' | 'SMALL';
    currentRouteWithoutId: string;
    indent?: boolean;
}>();
</script>
<template>
    <li
        :class="[
            'nav-item',
            indent ? 'ms-4' : '',
            menuitem.groupStart ? 'nav-item-group' : '',
            menuitem.groupStart ? 'border-top' : '',
            menuitem.groupStart ? 'mt-3' : '',
            menuitem.groupStart ? 'pt-2' : '',
        ]"
        :key="menuitem.name"
        v-if="menuitem.isVisible(size, eventID)"
    >
        <RouterLink
            :path="menuitem.path(eventID)"
            :class="{ 'link-active': menuitem.isInRoute(currentRouteWithoutId, true, eventID) }"
            class="nav-link position-relative"
            aria-current="page"
            :title="$tm(menuitem.translationKey)"
        >
            <span
                class="menuitem-icon position-relative"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-offset="0,30"
                :data-bs-title="$tm(menuitem.translationKey)"
            >
                <IconComp
                    :icon="menuitem.icon"
                    class="me-3 fa-fw"
                />

                <span
                    v-if="menuitem.getStatus() != 'HIDDEN'"
                    :class="[
                        menuitem.getStatus() == 'ONLINE' ? 'bg-success' : menuitem.getStatus() == 'OFFLINE' ? 'bg-danger' : 'bg-warning',
                    ]"
                    class="position-absolute top-90 start-75 translate-middle p-2 border rounded-circle"
                ></span>
            </span>
            <span class="menuitem-text">{{ $tm(menuitem.translationKey) }}</span>
            <span
                v-if="(menuitem.badgecount ?? 0) > 0"
                class="badge bg-primary text-white rounded-pill position-absolute end-0 me-2"
                >{{ menuitem.badgecount }}</span
            >
            <span
                v-if="menuitem.badgetext"
                class="badge bg-warning text-dark rounded-pill position-absolute end-0 top-25 ms-4"
                >{{ menuitem.badgetext }}</span
            >
        </RouterLink>
    </li>
</template>
